import React from 'react';
import MFDRoomTabContent from './MFDRoomTabContent/MFDRoomTabContent';

interface Asas1DCTabsContentProps {
    tabs: Array<{ id: string; label: string; content: React.ReactNode }>;
    selectedTab: string;
    setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
}

const Asas1DCTabsContent: React.FC<Asas1DCTabsContentProps> = ({tabs, selectedTab, setSelectedTab}) => {
    const [selectedCrackScreen, setSelectedCrackScreen] = React.useState<string | null>(null);

  return (
    <>
       {!selectedCrackScreen && (

         <div className="flex items-center gap-5 mb-2">
                {tabs.map((tab) =>
                    <div onClick={() => setSelectedTab(tab.id)} key={tab.id} className={`px-2 py-1  bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer ${selectedTab === tab.id ? 'bg-gradient-to-r from-[#7ED34E] to-[#2E968A] text-white' : ''}`}>
                        <h3 className="text-[12px] font-medium">{tab.label}</h3>
                    </div>
                )}
            </div>
       )}
    {selectedTab === "mdfRoom" && (
        <MFDRoomTabContent selectedTab={selectedTab} selectedCrackScreen={selectedCrackScreen} setSelectedCrackScreen={setSelectedCrackScreen}/>
    )}
    {selectedTab === "room1" && (
        <div>room1 Content</div>
    )}
    {selectedTab === "room2" && (
        <div>room2 Content</div>
    )}
    </>
  );
};

export default Asas1DCTabsContent;